export default __webpack_public_path__ + "static/media/staff-icon-gray.622e2b7c.svg";